import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next/types';
import { getSession, signIn } from 'next-auth/react';
import { useEffect } from 'react';

import MainLoader from '../components/Loader';

const Authenticated = ({ referer }: { referer: string }) => {
  const router = useRouter();

  useEffect(() => {
    router.push(referer);
  }, [referer, router]);
  return <>{<MainLoader />}</>;
};
const UnAuthenticated = ({ referer }: { referer: string }) => {
  useEffect(() => {
    signIn('azure-ad-b2c', { callbackUrl: referer }, { ui_locales: 'en' });
  }, [referer]);
  return <MainLoader />;
};

const SigninPage = ({
  authenticated,
  referer,
}: {
  authenticated: boolean;
  referer: string;
}) => {
  if (authenticated) return <Authenticated referer={referer} />;
  return <UnAuthenticated referer={referer} />;
};
export const getServerSideProps: GetServerSideProps = async context => {
  const session = await getSession({ req: context.req });
  context.res.setHeader(
    'Cache-Control',
    'no-store, no-cache, must-revalidate, proxy-revalidate',
  );
  return {
    props: {
      authenticated: !!session?.user,
      referer: context.req.headers.referer,
    },
  };
};
export default SigninPage;
